import { render, staticRenderFns } from "./updatedPromoCode.vue?vue&type=template&id=03220d7a&scoped=true"
import script from "./updatedPromoCode.vue?vue&type=script&lang=js"
export * from "./updatedPromoCode.vue?vue&type=script&lang=js"
import style0 from "./updatedPromoCode.vue?vue&type=style&index=0&id=03220d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03220d7a",
  null
  
)

export default component.exports